const roots = document.querySelectorAll('.board-of-directors')

const tabNameFromHash = () => (window.location.hash === '#leadership' ? 'leadership' : 'board')

const syncPeopleTabs = (name) => {
    roots.forEach((root) => {
        root.setAttribute('data-people-tab', name)

        root.querySelectorAll('.board-of-directors__tab').forEach((tab) => {
            const selected = tab.getAttribute('href') === `#${name}`
            tab.setAttribute('aria-selected', selected ? 'true' : 'false')
            tab.tabIndex = selected ? 0 : -1
        })
    })
}

const showTab = (name, updateHistory) => {
    const scrollX = window.scrollX
    const scrollY = window.scrollY

    if (updateHistory && window.location.hash !== `#${name}`) {
        history.pushState(null, '', `#${name}`)
    }

    syncPeopleTabs(name)
    window.scrollTo(scrollX, scrollY)
}

roots.forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('.board-of-directors__tab'))

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
            event.preventDefault()
            const name = tab.getAttribute('href') === '#leadership' ? 'leadership' : 'board'
            showTab(name, true)
        })

        tab.addEventListener('keydown', (event) => {
            let nextIndex = null

            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                nextIndex = (index + 1) % tabs.length
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                nextIndex = (index - 1 + tabs.length) % tabs.length
            } else if (event.key === 'Home') {
                nextIndex = 0
            } else if (event.key === 'End') {
                nextIndex = tabs.length - 1
            }

            if (nextIndex === null) {
                return
            }

            event.preventDefault()
            const next = tabs[nextIndex]
            const name = next.getAttribute('href') === '#leadership' ? 'leadership' : 'board'
            showTab(name, true)
            next.focus({ preventScroll: true })
        })
    })
})

syncPeopleTabs(tabNameFromHash())
window.addEventListener('popstate', () => {
    showTab(tabNameFromHash(), false)
})
